(function () {
    'use strict';
    eoNumericInputController.$inject = ['$scope', '$attrs', '$element'];

    function eoNumericInputController($scope, $attrs, $element) {
        var $ctrl = this;


        $scope.$watch($ctrl.formReference.$invalid, function (invalid) {
            //this code check the form errors
            // DO NOT DELETE THIS !!!!
        })


        $ctrl.onValueChange = function () {
            replaceIosNumbers();
            replaceAndroidNumbers();
            removeInvalidCharacter();

            if ($ctrl.onChange)
                $ctrl.onChange();
        }

        $ctrl.getClass = function () {
            return $ctrl.customClass;
        }


        function replaceIosNumbers() {
            if (!$ctrl.inputValue)
                return;
            var corrected = $ctrl.inputValue;
            for (var i = 0; i < $ctrl.inputValue.length; i++) {
                var charCode = $ctrl.inputValue.charCodeAt(i);
                if (charCode == 1632)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "0");
                if (charCode == 1633)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "1");
                if (charCode == 1634)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "2");
                if (charCode == 1635)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "3");
                if (charCode == 1636)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "4");
                if (charCode == 1637)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "5");
                if (charCode == 1638)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "6");
                if (charCode == 1639)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "7");
                if (charCode == 1640)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "8");
                if (charCode == 1641)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "9");


            }
            $ctrl.inputValue = corrected;
        }

        function replaceAndroidNumbers() {
            if (!$ctrl.inputValue)
                return;
            var corrected = $ctrl.inputValue;
            for (var i = 0; i < $ctrl.inputValue.length; i++) {
                var charCode = $ctrl.inputValue.charCodeAt(i);
                if (charCode == 1776)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "0");
                if (charCode == 1777)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "1");
                if (charCode == 1778)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "2");
                if (charCode == 1779)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "3");
                if (charCode == 1780)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "4");
                if (charCode == 1781)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "5");
                if (charCode == 1782)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "6");
                if (charCode == 1783)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "7");
                if (charCode == 1784)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "8");
                if (charCode == 1785)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "9");


            }
            $ctrl.inputValue = corrected;
        }

        function isValidNumber(char) {

            if (char == '0'
                || char == '1'
                || char == '2'
                || char == '3'
                || char == '4'
                || char == '5'
                || char == '6'
                || char == '7'
                || char == '8'
                || char == '9'
            )
                return true;

            return false;

        }

        function removeInvalidCharacter() {
            if (!$ctrl.inputValue)
                return;
            var corrected = $ctrl.inputValue;
            for (var i = 0; i < $ctrl.inputValue.length; i++) {
                var ccc = $ctrl.inputValue.charCodeAt(i);
                if (!isValidNumber($ctrl.inputValue.charAt(i))) {
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), '');
                }
            }

            $ctrl.inputValue = corrected;

        }

    }

    var eo_NumericInput = {

        templateUrl: 'app/components/eyeson/numeric-input/eyeson.numeric-input.template.html',
        controller: eoNumericInputController,
        bindings: {
            name: '@',
            inputValue: "=",
            customClass: "@",
            isDisabled: "=?",
            isRequired: "=?",
            formReference: '<',
            min: '@',
            maxlength: "=?",
            minlength: '@',
            placeholder: '@',
            onChange: '=?'

        }
    };
    angular
        .module('tikonApp')
        .component('eoNumericInput', eo_NumericInput);

})();

